import { MathUtils } from 'three';

// Traffic board colors
export const TRAFFIC_BOARD_BLUE = '#1976D2';
export const TRAFFIC_BOARD_RED = '#D32F2F';

// Scaling ratio's for auto-scaling traffic boards based on logical space size.
const TRAFFIC_BOARD_CROSS_THICKNESS_RATIO = 0.17;
const TRAFFIC_BOARD_CROSS_LENGTH_RATIO = 1.7;

export const TRAFFIC_BOARD_STACK_GAP = 0.5;

// Traffic board layout constraints in meters.
export const TRAFFIC_BOARD_MIN_RADIUS = 0.6;
export const TRAFFIC_BOARD_MAX_RADIUS = 6;
export const TRAFFIC_BOARD_EDGE_PADDING = 1;
export const TRAFFIC_BOARD_RADIUS = 1;

export const VEHICLE_MODE_OFFSET = 0.7;
export const VEHICLE_MODE_LABEL_MAX_CHARS = 7;

export const TRAFFIC_BOARD_CROSS_THICKNESS =
  TRAFFIC_BOARD_RADIUS * TRAFFIC_BOARD_CROSS_THICKNESS_RATIO;
export const TRAFFIC_BOARD_CROSS_LENGTH = TRAFFIC_BOARD_RADIUS * TRAFFIC_BOARD_CROSS_LENGTH_RATIO;

export const TRAFFIC_BOARD_STROKE_MULTIPLIER = 200;

export const DO_NOT_STOP_CROSS_ANGLE = MathUtils.degToRad(45);
